<template>
  <!-- Sidebar -->
  <ul
    class="navbar-nav custom-sidebar sidebar sidebar-dark accordion"
    id="accordionSidebar"
    v-if="isAuthenticated"
  >
    <!-- Sidebar - Brand -->
    <router-link
      class="sidebar-brand d-flex align-items-center justify-content-center"
      :to="{ name: 'home' }"
    >
      <div class="sidebar-brand-icon rotate-n-15">
        <!-- <i class="fas fa-flag"></i> -->
      </div>
      <div class="sidebar-brand-text mx-3">
        <!-- eVisa Bénin
        <sup>NG</sup> -->
        <img src="@/assets/logo-evisa.png" />
      </div>
    </router-link>

    <!-- Divider -->
    <hr class="sidebar-divider my-0" />

    <!-- Nav Item - Dashboard -->
    <li class="nav-item active">
      <router-link :to="{ name: 'home' }" class="nav-link">
        <i class="fas fa-fw fa-tachometer-alt"></i>
        <span>Tableau de Board</span>
      </router-link>
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Heading -->
    <div class="sidebar-heading">visas</div>

    <!-- Nav Item - Pages Collapse Menu -->
    <li class="nav-item">
      <router-link
        to=""
        class="nav-link collapsed"
        data-toggle="collapse"
        data-target="#collapseTwo"
        aria-expanded="true"
        aria-controls="collapseTwo"
      >
        <i class="fas fa-fw fa-cog"></i>
        <span>Les demandes</span>
      </router-link>
      <div
        id="collapseTwo"
        class="collapse"
        aria-labelledby="headingTwo"
        data-parent="#accordionSidebar"
      >
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Gestion des demandes:</h6>

          <router-link
            :to="{ name: 'evisas' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
            :class="{
              'active-item': ['evisas', 'evisa-view'].includes(currentPathName),
            }"
            >Déjà générées (e-Visas)
          </router-link>
          <router-link
            :to="{ name: 'matcheds' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
            :class="{
              'active-item': ['matcheds', 'matched-view'].includes(
                currentPathName
              ),
            }"
            >En attente de validation
          </router-link>
          <router-link
            :to="{ name: 'demands' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
            :class="{
              'active-item': ['demands', 'demand-view'].includes(
                currentPathName
              ),
            }"
            >Toutes les demandes
          </router-link>
          <!-- <router-link
            :to="{ name: 'demands-unpaid' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
            :class="{
              'active-item': [
                'demands-unpaid',
                'demands-unpaid-view',
              ].includes(currentPathName),
            }"
            >Demandes non payées
          </router-link> -->
        </div>
      </div>
    </li>

    <!-- Nav Item - Utilities Collapse Menu -->
    <li class="nav-item">
      <router-link
        to=""
        class="nav-link collapsed"
        data-toggle="collapse"
        data-target="#collapseUtilities"
        aria-expanded="true"
        aria-controls="collapseUtilities"
      >
        <i class="fas fa-fw fa-wrench"></i>
        <span>Paramétrages</span>
      </router-link>
      <div
        id="collapseUtilities"
        class="collapse"
        aria-labelledby="headingUtilities"
        data-parent="#accordionSidebar"
      >
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Configurations:</h6>
          <router-link
            :to="{ name: 'prices' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_PRICE,
                  P_READ_PRICE,
                  P_UPDATE_PRICE,
                  P_DELETE_PRICE,
                ].includes(e)
              )
            "
            :class="{
              'active-item': ['prices', 'price-create', 'price-edit'].includes(
                currentPathName
              ),
            }"
            >Tarifications</router-link
          >
          <router-link
            :to="{ name: 'visatypes' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_VISATYPE,
                  P_READ_VISATYPE,
                  P_UPDATE_VISATYPE,
                  P_DELETE_VISATYPE,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'visatypes',
                'visatype-create',
                'visatype-edit',
              ].includes(currentPathName),
            }"
            >Types de e-Visa</router-link
          >
          <router-link
            :to="{ name: 'countries' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_COUNTRY,
                  P_READ_COUNTRY,
                  P_UPDATE_COUNTRY,
                  P_DELETE_COUNTRY,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'countries',
                'country-create',
                'country-edit',
              ].includes(currentPathName),
            }"
            >Pays</router-link
          >
          <router-link
            :to="{ name: 'users' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_USER,
                  P_READ_USER,
                  P_UPDATE_USER,
                  P_DELETE_USER,
                ].includes(e)
              )
            "
            :class="{
              'active-item': ['users', 'user-create', 'user-edit'].includes(
                currentPathName
              ),
            }"
            >Utilisateurs</router-link
          >
          <router-link
            :to="{ name: 'profiles' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_PROFILE,
                  P_READ_PROFILE,
                  P_UPDATE_PROFILE,
                  P_DELETE_PROFILE,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'profiles',
                'profile-create',
                'profile-edit',
              ].includes(currentPathName),
            }"
            >Profils</router-link
          >
          <router-link
            :to="{ name: 'actions' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_ACTION].includes(e))"
            :class="{
              'active-item': [
                'actions',
                'action-create',
                'action-edit',
              ].includes(currentPathName),
            }"
            >Actions</router-link
          >
          <router-link
            :to="{ name: 'articles' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_ARTICLE,
                  P_READ_ARTICLE,
                  P_UPDATE_ARTICLE,
                  P_DELETE_ARTICLE,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'articles',
                'article-create',
                'article-edit',
              ].includes(currentPathName),
            }"
            >Articles</router-link
          >
          <router-link
            :to="{ name: 'wanteds' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_WANTED,
                  P_READ_WANTED,
                  P_UPDATE_WANTED,
                  P_DELETE_WANTED,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'wanteds',
                'wanted-create',
                'wanted-edit',
              ].includes(currentPathName),
            }"
            >Liste rouge
          </router-link>
          <router-link
            :to="{ name: 'faqs' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [P_CREATE_FAQ, P_READ_FAQ, P_UPDATE_FAQ, P_DELETE_FAQ].includes(
                  e
                )
              )
            "
            :class="{
              'active-item': ['faqs', 'faq-create', 'faq-edit'].includes(
                currentPathName
              ),
            }"
            >Faq
          </router-link>
          <router-link
            :to="{ name: 'links' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_LINK,
                  P_READ_LINK,
                  P_UPDATE_LINK,
                  P_DELETE_LINK,
                ].includes(e)
              )
            "
            :class="{
              'active-item': ['links', 'link-create', 'link-edit'].includes(
                currentPathName
              ),
            }"
            >Liens utiles
          </router-link>
          <router-link
            :to="{ name: 'images' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
            :class="{
              'active-item': ['images', 'image-create', 'image-edit'].includes(
                currentPathName
              ),
            }"
            >Images e-Visa  
          </router-link>

          <router-link
            :to="{ name: 'parametres' }"
            class="collapse-item"
            v-if="userPermissions.some((e) => [P_PARAM_MASTER].includes(e))"
            :class="{
              'active-item': ['parametres', 'parametre-edit'].includes(
                currentPathName
              ),
            }"
            >Paramètres
          </router-link>

          <!-- <router-link
            :to="{ name: 'partners' }"
            class="collapse-item"
            v-if="
              userPermissions.some((e) =>
                [
                  P_CREATE_PARTNER,
                  P_READ_PARTNER,
                  P_UPDATE_PARTNER,
                  P_DELETE_PARTNER,
                ].includes(e)
              )
            "
            :class="{
              'active-item': [
                'partners',
                'partner-create',
                'partner-edit',
              ].includes(currentPathName),
            }"
            >Partenaires
          </router-link> -->
        </div>
      </div>
    </li>

    <!-- Divider -->
    <hr
      v-if="
        userPermissions.some((e) =>
          [P_REPORT_MASTER, P_STAT_MASTER].includes(e)
        )
      "
      class="sidebar-divider"
    />

    <!-- Heading -->
    <div
      class="sidebar-heading"
      v-if="
        userPermissions.some((e) =>
          [P_REPORT_MASTER, P_STAT_MASTER].includes(e)
        )
      "
    >
      Rapports et Statistiques
    </div>

    <li class="nav-item" key="rppt">
      <router-link
        :to="{ name: 'report-demands' }"
        class="nav-link"
        key="rapport"
        v-if="userPermissions.some((e) => [P_REPORT_MASTER].includes(e))"
      >
        <i class="fas fa-fw fa-chart-area" key="rapporti"></i>
        <span>Rapports</span>
      </router-link>
    </li>

    <li class="nav-item">
      <router-link
        :to="{ name: 'report-stats' }"
        class="nav-link"
        v-if="userPermissions.some((e) => [P_STAT_MASTER].includes(e))"
      >
        <i class="fas fa-fw fa-chart-pie" key="stats"></i>
        <span>Statistiques</span>
      </router-link>
    </li>

    <!-- Nav Item - Pages Collapse Menu -->
    <!-- <li class="nav-item">
      <router-link
        to="#"
        class="nav-link collapsed"
        data-toggle="collapse"
        data-target="#collapseRS1"
        aria-expanded="true"
        aria-controls="collapseRS1"
      >
        <i class="fas fa-fw fa-cog"></i>
        <span>Rapports</span>
      </router-link>
      <div
        id="collapseRS1"
        class="collapse"
        aria-labelledby="headingRS1"
        data-parent="#accordionSidebar"
      >
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Gestion des rapports:</h6>
          <router-link
            :to="{ name: 'report-demands' }"
            class="collapse-item"
            :class="{
              'active-item': ['report-demands'].includes(currentPathName),
            }"
          >
            Toutes les demandes
          </router-link>
          <router-link to="buttons.html" class="collapse-item">
            Demandes en attente
          </router-link>
          <router-link to="cards.html" class="collapse-item">
            Les e-Visas
          </router-link>
        </div>
      </div>
    </li> -->

    <!-- Nav Item - Utilities Collapse Menu -->
    <!-- <li class="nav-item">
      <router-link
        to="#"
        class="nav-link collapsed"
        data-toggle="collapse"
        data-target="#collapseRS2"
        aria-expanded="true"
        aria-controls="collapseRS2"
      >
        <i class="fas fa-fw fa-wrench"></i>
        <span>Statistiques</span>
      </router-link>
      <div
        id="collapseRS2"
        class="collapse"
        aria-labelledby="headingRS2"
        data-parent="#accordionSidebar"
      >
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Statistiques:</h6>
          <router-link to="utilities-color.html" class="collapse-item"
            >Tarifications</router-link
          >
          <router-link to="utilities-border.html" class="collapse-item"
            >Types de eVisa</router-link
          >
          <router-link to="utilities-animation.html" class="collapse-item"
            >Pays</router-link
          >
          <router-link to="utilities-other.html" class="collapse-item"
            >Utilisateurs</router-link
          >
          <router-link to="utilities-other.html" class="collapse-item"
            >Profiles</router-link
          >
          <router-link to="utilities-other.html" class="collapse-item"
            >Rôles</router-link
          >
        </div>
      </div>
    </li> -->

    <hr
      v-if="
        userPermissions.some((e) => [P_REVIEW_MASTER, P_LOG_MASTER].includes(e))
      "
      class="sidebar-divider"
    />

    <!-- Heading -->
    <div
      class="sidebar-heading"
      v-if="
        userPermissions.some((e) => [P_REVIEW_MASTER, P_LOG_MASTER].includes(e))
      "
    >
      Avis et Logs
    </div>

    <!-- Nav Item - Charts -->
    <li class="nav-item">
      <router-link
        :to="{ name: 'reviews' }"
        class="nav-link"
        v-if="userPermissions.some((e) => [P_REVIEW_MASTER].includes(e))"
      >
        <i class="fas fa-fw fa-file-alt" key="reviews"></i>
        <span>Avis clients</span>
      </router-link>
    </li>

    <!-- Divider -->
    <hr
      v-if="userPermissions.some((e) => [P_LOG_MASTER].includes(e))"
      class="sidebar-divider"
    />

    <!-- Nav Item - Charts -->
    <li class="nav-item">
      <router-link
        :to="{ name: 'logs' }"
        class="nav-link"
        v-if="userPermissions.some((e) => [P_LOG_MASTER].includes(e))"
      >
        <i class="fas fa-fw fa-file-alt" key="logs"></i>
        <span>Logs</span>
      </router-link>
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />

    <!-- Sidebar Toggler (Sidebar) -->
    <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
    </div>
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
import { mapGetters } from "vuex";
import {
  P_READ_ACTION,
  P_CREATE_ARTICLE,
  P_READ_ARTICLE,
  P_UPDATE_ARTICLE,
  P_DELETE_ARTICLE,
  P_CREATE_COUNTRY,
  P_READ_COUNTRY,
  P_UPDATE_COUNTRY,
  P_DELETE_COUNTRY,
  P_READ_DEMAND,
  VISA_VALIDATION,
  VISA_GENERATION,
  P_CREATE_PRICE,
  P_READ_PRICE,
  P_UPDATE_PRICE,
  P_DELETE_PRICE,
  P_CREATE_PROFILE,
  P_READ_PROFILE,
  P_UPDATE_PROFILE,
  P_DELETE_PROFILE,
  P_CREATE_USER,
  P_READ_USER,
  P_UPDATE_USER,
  P_DELETE_USER,
  P_CREATE_VISATYPE,
  P_READ_VISATYPE,
  P_UPDATE_VISATYPE,
  P_DELETE_VISATYPE,
  P_CREATE_WANTED,
  P_READ_WANTED,
  P_UPDATE_WANTED,
  P_DELETE_WANTED,
  P_CREATE_FAQ,
  P_READ_FAQ,
  P_UPDATE_FAQ,
  P_DELETE_FAQ,
  P_REPORT_MASTER,
  P_LOG_MASTER,
  P_STAT_MASTER,
  P_REVIEW_MASTER,
  P_PARAM_MASTER,
  P_READ_LINK,
  P_CREATE_LINK,
  P_UPDATE_LINK,
  P_DELETE_LINK,
  P_READ_PARTNER,
  P_CREATE_PARTNER,
  P_UPDATE_PARTNER,
  P_DELETE_PARTNER,
} from "@/helpers/permissions";

export default {
  data() {
    return {
      P_READ_ACTION,
      P_CREATE_ARTICLE,
      P_READ_ARTICLE,
      P_UPDATE_ARTICLE,
      P_DELETE_ARTICLE,
      P_CREATE_COUNTRY,
      P_READ_COUNTRY,
      P_UPDATE_COUNTRY,
      P_DELETE_COUNTRY,
      P_READ_DEMAND,
      VISA_VALIDATION,
      VISA_GENERATION,
      P_CREATE_PRICE,
      P_READ_PRICE,
      P_UPDATE_PRICE,
      P_DELETE_PRICE,
      P_CREATE_PROFILE,
      P_READ_PROFILE,
      P_UPDATE_PROFILE,
      P_DELETE_PROFILE,
      P_CREATE_USER,
      P_READ_USER,
      P_UPDATE_USER,
      P_DELETE_USER,
      P_CREATE_VISATYPE,
      P_READ_VISATYPE,
      P_UPDATE_VISATYPE,
      P_DELETE_VISATYPE,
      P_CREATE_WANTED,
      P_READ_WANTED,
      P_UPDATE_WANTED,
      P_DELETE_WANTED,
      P_CREATE_FAQ,
      P_READ_FAQ,
      P_UPDATE_FAQ,
      P_DELETE_FAQ,
      P_REPORT_MASTER,
      P_LOG_MASTER,
      P_STAT_MASTER,
      P_REVIEW_MASTER,
      P_PARAM_MASTER,
      P_READ_LINK,
      P_CREATE_LINK,
      P_UPDATE_LINK,
      P_DELETE_LINK,
      P_READ_PARTNER,
      P_CREATE_PARTNER,
      P_UPDATE_PARTNER,
      P_DELETE_PARTNER,
    };
  },
  mounted() {
    this.menu();
  },
  computed: {
    ...mapGetters(["isAuthenticated", "userPermissions", "currentPathName"]),
  },
  methods: {
    menu() {
      let mcontainer = document.getElementById("accordionSidebar");
      let menus = mcontainer
        ? mcontainer.getElementsByClassName("nav-item")
        : "";
      mcontainer ? this.setActiveMenu(menus, menus) : null;
    },
    setActiveMenu(menus) {
      for (let i = 0; i < menus.length; i++) {
        menus[i].addEventListener("click", function () {
          let current = document.getElementsByClassName("active");
          // If there's no active class
          if (current.length > 0) {
            current[0].className = current[0].className.replace(" active", "");
          }
          // Add the active class to the current/clicked button
          this.className += " active";
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
// $base-color: #0a3764;

.custom-sidebar {
  background-color: $base-color;
}
@media (min-width: 768px) {
  .sidebar {
    width: 18rem !important;
  }
  .sidebar .nav-item .nav-link {
    width: 18rem;
  }
  .sidebar .nav-item .nav-link span {
    font-size: 1.1rem;
    display: inline;
  }
}
.sidebar .nav-item .collapse .collapse-inner,
.sidebar .nav-item .collapsing .collapse-inner {
  font-size: 1rem;
}

.sidebar .sidebar-heading {
  font-size: 0.85rem;
}

.sidebar .nav-item .collapse .collapse-inner .collapse-header,
.sidebar .nav-item .collapsing .collapse-inner .collapse-header {
  font-size: 0.85rem;
}
.sidebar .sidebar-brand {
  font-size: 1.4rem;
  height: unset;
}

.active-item {
  color: $base-color !important;
  font-weight: bold !important;
  background-color: #d0d4e4 !important;
}
</style>